import { Injectable } from '@angular/core';
import { DriverImageClientData } from '@max/driver/models/driver-image-model';
import { BaseApiService } from '@max/shared/base-service/base-api.service';
import { BusinessTransactionOverrideModel } from '@max/shared/models/business-transaction/business-transaction-override.model';
import { ValidatedResponse } from '@max/shared/models/validated-response.model';
import { AgentImage } from '@max/transaction/models/agent-image.model';
import { Observable } from 'rxjs';
import { ProcessDriverImageRequest } from '../../driver/models/process-driver-image-request.model';
import { ProcessedDriverImageResult } from '../../driver/models/processed-driver-image-result.model';

@Injectable()
export class CustomerImageService extends BaseApiService {
    constructor() {
        super();
    }

    public getDriverTopOfStackPortrait = (customerNumberId: number): Observable<{ result: string }> => this.get(`Customer/Image/DriverPhoto/TopOfStack/Portrait/${customerNumberId}`);

    public getDriverTopOfStackSignature = (customerNumberId: number): Observable<{ result: string }> => this.get(`Customer/Image/DriverPhoto/TopOfStack/Signature/${customerNumberId}`);

    public getRecentPortrait = (customerNumberId: number): Observable<{ result: string }> => this.get(`Customer/Image/DriverPhoto/Recent/Portrait/${customerNumberId}`);

    public getRecentSignature = (customerNumberId: number): Observable<{ result: string }> => this.get(`Customer/Image/DriverPhoto/Recent/Signature/${customerNumberId}`);

    public getDriverCredentialPortrait = (credentialNumberId: number): Observable<{ result: string }> => this.get(`Customer/Image/DriverPhoto/Credential/Portrait/${credentialNumberId}`);

    public getDriverCredentialSignature = (credentialNumberId: number): Observable<{ result: string }> => this.get(`/Customer/Image/DriverPhoto/Credential/Signature/${credentialNumberId}`);

    public getDriverPortrait = (imageId: string): Observable<{ result: string }> => this.get(`Customer/Image/DriverPhoto/Portrait/${imageId}`);

    public getDriverImageSignature = (imageId: string): Observable<{ result: string }> => this.get(`Customer/Image/DriverPhoto/Signature/${imageId}`);

    public getDriverPhotoUnassociated = (ident: string): Observable<{ result: string }> => this.get(`Customer/Image/DriverPhoto/Unassociated/${ident}`);

    public getPriorPhotoPresent = (customerNumberId: number) => this.get('Customer/Image/DriverPhoto/PriorPhotoPresent/' + customerNumberId);

    public getRecentPhotos = (agentIds: number[]): Observable<ValidatedResponse<AgentImage[]>> => this.post('Customer/Image/CustomerPhotos/Recent/Portrait', agentIds);

    public updateTransactionDriverImageIdOld = (businessTransactionId: number, driverImageId: number): Observable<number> => this.post(`Driver/CredentialIssuanceApplication/Transaction/${businessTransactionId}/DriverImageOld`, driverImageId);

    public updateTransactionDriverImageIdNew = (businessTransactionId: number, driverImageId: number): Observable<number> => this.post(`Driver/CredentialIssuanceApplication/Transaction/${businessTransactionId}/DriverImage`, driverImageId);

    public getTopOfStackInformation = (customerNumberId: number): Observable<DriverImageClientData> => this.getMaxResult('Customer/Image/DriverPhoto/Information/TopOfStack/' + customerNumberId);

    public createImageOverride = (businessTransactionId: number, validationResourceId: number, requsetedValue: string, message: string): Observable<BusinessTransactionOverrideModel> => this.post(`Foundation/BusinessTransaction/${businessTransactionId}/approval/${validationResourceId}/${requsetedValue}`, message);

    public saveDriverImage = (customerNumberId: number, driverImageData: DriverImageClientData): Observable<any> => this.post(`Customer/Image/DriverPhoto/Save/${customerNumberId}`, driverImageData, this.replacer);

    public saveDriverImagePull = (customerNumberId: number, driverImageData: DriverImageClientData): Observable<DriverImageClientData> => this.post(`Customer/Image/DriverPhoto/Save/${customerNumberId}/Pull`, driverImageData, this.replacer);

    public getRecentDriverPhotoExists = (customerNumberId: number) => this.get(`Customer/Image/DriverPhoto/Recent/Exists/${customerNumberId}`);

    public getDriverTempPortraitWip = (businessTransactionId: number): Observable<DriverImageClientData> => this.getMaxResult('Driver/CredentialIssuanceApplication/Transaction/' + businessTransactionId + '/DriverPortrait');
    public getDriverTempSignatureWip = (businessTransactionId: number): Observable<string> => this.getMaxResult('Driver/CredentialIssuanceApplication/Transaction/' + businessTransactionId + '/DriverSignature');

    public isCustomerRedacted = (customerNumberId: number) => this.get(`Customer/Characteristics/IsRestricted/${customerNumberId}`);

    public canUseExistingPhotoAndSignature = (customerNumberId: number) => this.get(`Customer/Characteristics/CanUseExistingPhotoAndSignature/${customerNumberId}`);

    public getAllDriverCredentials = (customerNumberId: number) => this.get(`Customer/Image/DriverPhoto/Credentials/${customerNumberId}`);

    public getDriverImageStatusTypes = () => this.get('customer/Image/DriverImageStatusTypes');

    public saveDriverImageData = (clientData: DriverImageClientData) => this.post('Customer/Image/DriverPhoto/SaveData', clientData);

    public getTopOfStackInformationForTransaction = (customerNumberId: number, businessTransactionId: number): Observable<DriverImageClientData> => this.get(`Driver/CredentialIssuanceApplication/DriverPhoto/TopOfStack/${customerNumberId}/${businessTransactionId}`);

    public getTransactionPortrait = (businessTransactionNumberId: number): Observable<{ result: string }> => this.get(`Driver/CredentialIssuanceApplication/Transaction/Portrait/${businessTransactionNumberId}`);

    public getTransactionSignature = (businessTransactionNumberId: number): Observable<{ result: string }> => this.get(`Driver/CredentialIssuanceApplication/Transaction/Signature/${businessTransactionNumberId}`);

    public processDriverImage = (imageRequest: ProcessDriverImageRequest): Observable<ValidatedResponse<ProcessedDriverImageResult>> => this.post('Customer/Image/ProcessDriverImage', imageRequest);

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }
        return value;
    }
}
